import { Column } from '../objects/column';
import { Preferences } from '../../profile/objects/preferences';
import { ListPreferenceResult, setListPreference } from '../../utils/list/utils/setListPreference';

export const DESTINATION_CATEGORY_MODULE = 'DESTINATION_CATEGORY';

export const DEFAULT_DESTINATION_CATEGORY_COLUMNS: Column[] = [
    { label: 'name', field_name: 'NAME', checked: true, order_by: 'name', fixed_width: false, last_updated: false, width: null },
    { label: 'created-date', field_name: 'CREATED_DATE', checked: true, order_by: 'created_date', fixed_width: true, last_updated: false, width: null },
    { label: 'created-by', field_name: 'CREATED_BY', checked: true, order_by: 'creator__username', fixed_width: true, last_updated: false, width: null },
    { label: 'modified-date', field_name: 'MODIFIED_DATE', checked: true, order_by: 'modified_date', fixed_width: true, last_updated: false, width: null },
    { label: 'modified-by', field_name: 'MODIFIED_BY', checked: true, order_by: 'last_author__username', fixed_width: true, last_updated: false, width: null },
];

export const setDestinationCategoryPreference = (prefs: Preferences[], cols: Column[]): ListPreferenceResult =>
    setListPreference(prefs, cols, {
        module: DESTINATION_CATEGORY_MODULE,
        default_columns: DEFAULT_DESTINATION_CATEGORY_COLUMNS,
        default_order_by: 'name',
        default_order: 'asc',
    });
